import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateProjectPersonnelMutation({ projectId }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ _page = null, id, projectPersonnelParams }) => {
      const response = await axios.patch(`/project_personnel/${id}`, {
        project_personnel: projectPersonnelParams,
      });

      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(
        [
          'projects',
          projectId,
          'projectPersonnel',
          variables.page && { page: variables.page },
        ].filter(Boolean),
      );
    },
  });
}

export function useDestroyProjectPersonnelMutation({ projectId }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(`/project_personnel/${id}`);

      return response.data;
    },
    onSuccess: () => {
      [
        'assignablePersonnelSearches',
        'companyRoleSearches',
        'projectPersonnel',
        'signatureStatus',
        'teamSearches',
      ].forEach((queryKeySegment) =>
        queryClient.invalidateQueries(['projects', projectId, queryKeySegment]),
      );
    },
  });
}
